let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ePB8L")).then(() => parcelRequire('kHQ2z'));